// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lab-form-sheet[data-v-08d930c0]{margin-bottom:8px}.origin-loading[data-v-08d930c0]{padding:24px;text-align:center;color:#909399}.origin-loading--err[data-v-08d930c0]{color:#e6a23c}.origin-form-title[data-v-08d930c0]{text-align:center;font-size:15px;font-weight:700;padding:10px 8px;border:1px solid #333;border-bottom:none;background:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
